exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-60f35ab6]:export{menuText:#606266;menuActiveText:#fa8c16;subMenuActiveText:#fa8c16;menuBg:#fff;menuHover:#fff7e6;subMenuBg:#fafafa;subMenuHover:#fff7e6;sideBarWidth:220px;primaryColor:#fa8c16;bgColor:#fdfbf7}.app-wrapper[data-v-60f35ab6]:after{content:\"\";display:table;clear:both}.app-wrapper[data-v-60f35ab6]{position:relative;height:100%;width:100%;background-color:#fdfbf7}.app-wrapper.mobile.openSidebar[data-v-60f35ab6]{position:fixed;top:0}.drawer-bg[data-v-60f35ab6]{background:rgba(0,0,0,.4);width:100%;top:0;height:100%;position:absolute;z-index:999;backdrop-filter:blur(2px)}", ""]);

// exports
